import { FC } from 'react'
import { Modal } from 'Components/Modal/Modal'
import { EmployerMetaField } from 'Services/employerService'
import { MetaFieldForm } from './MetaFieldForm'

type MetaFieldModalProps = {
  showModal: boolean
  setShowModal: (show: boolean) => void
  metaField: EmployerMetaField | null
}

export const MetaFieldModal: FC<MetaFieldModalProps> = ({ showModal, setShowModal, metaField }) => (
  <Modal showModal={showModal} setShowModal={setShowModal}>
    <MetaFieldForm closeModal={() => setShowModal(false)} metaField={metaField} />
  </Modal>
)
